import { ProductEmissionSettings } from '@/features/settings/components';
import { useRequirePermissions } from '@/shared/hooks';
import { requirePermissions } from '@/shared/utils';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings/products/')({
  component: SettingsProductsRoute,
  beforeLoad: async () => {
    const hasPermission = await requirePermissions(['products.catalog.read']);
    if (!hasPermission) {
      throw redirect({ to: '/dashboard' });
    }
  },
});

function SettingsProductsRoute() {
  // Espelha o guard da API: a escrita é exclusiva do Administrador
  // (`products.catalog.write` + `@RequireGroups('insurer.administrator')`).
  const { hasPermission: canEdit } = useRequirePermissions({
    permissions: ['products.catalog.write'],
  });

  return <ProductEmissionSettings canEdit={Boolean(canEdit)} />;
}
